<template>
    <!-- 圆角弹窗（居中） -->
    <van-popup v-model="showModal" round :style="{ padding: '16px 10px' }" class="modal" get-container="body"
        @closed="closed">
        <div class="modal_box">
            <div class="title">
                {{ id }}&nbsp;{{ $t("下属") }}
            </div>
            <div class="date">
                Data<p>{{ date }}</p>
            </div>
            <van-loading v-if="loading" class="loading" />
            <div class="wrap">
                <Item v-for="item in list" :key="item.id" :item="item" class="item" @hanldeInvite="hanldeItem" />
            </div>
        </div>
        <img class="close_img" src="../../../assets/images/common/close.png" alt="" @click="close">
    </van-popup>
</template>

<script>
import { Popup, Loading } from 'vant';
import Fetch from '../../../utils/fetch';
import Item from './Item.vue';
import Vue from 'vue';
import moment from 'moment'
Vue.use(Popup).use(Loading);
export default {
    components: {
        Item
    },
    props: {
        params: {
            type: Object,
            default: () => ({})
        },
        id: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            list: [],
            loading: false,
            showModal: false
        }
    },
    computed: {
        date() {
            let val = ''
            const date = moment().format('DD/MM/YYYY');
            val = `${date}~${date}`
            console.log(this.params, this.params.startDate, 'this.params.startDate')
            if (this.params.startDate) {
                const { startDate, endDate } = this.params
                const startDateFormat = moment(startDate).format('DD/MM/YYYY')
                const endDateFormat = moment(endDate).format('DD/MM/YYYY')
                val = `${startDateFormat}~${endDateFormat}`
            }
            return val
        }
    },
    watch: {
        id(newval) {
            if (newval > 0) {
                this.list = []
                this.showModal = true
                this.getList()
            } else {
                this.showModal = false
            }
        },
    },
    methods: {
        getList() {
            this.loading = true
            Fetch('/agent/subActive', { ...this.params, user_id: 0, id: this.id }, { method: 'get' }).then(res => {
                // Fetch('/agent/subActive', {...this.params, id: this.id}).then(res => {
                this.list = res.data.list
                this.loading = false
            })
        },
        hanldeItem(item) {
            this.showModal = false
            this.$emit('hanldeItem', item)
        },
        closed() {
            this.showModal = false
            this.$emit('close')
        },
        close() {
            this.showModal = false
        }
    }
}
</script>
<style scoped lang="less">
@import '../../../assets/css/variables.less';

.modal {
    width: 90vw;
    top: 45%;
    max-height: 450px;
    background-color: @activityColor !important;
    display: flex;
    flex-direction: column;
    overflow-y: visible;

    .modal_box {
        height: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }

    .title {
        width: 100%;
        text-align: center;
        font-size: 15px;
        color: @textcolorf;
        margin-bottom: 16px;
    }

    .date {
        color: @textcolor3;
        font-size: 10px;
        margin-bottom: 10px;
        display: flex;

        p {
            margin: 0 2px;
            color: @textcolorf;
        }
    }

    .wrap {
        overflow-y: auto;
        flex: 1;
        height: 50%;
    }

    .item {
        position: relative;
        padding: 10px;
        border-radius: 4px;

        &:nth-of-type(odd) {
            background-color: @secondary-color !important;
        }
    }

    .loading {
        width: 100%;
        display: flex;
        justify-content: center;

        /deep/ .van-loading__spinner {
            width: 50px;
            height: 50px;
        }
    }

    .close_img {
        position: absolute;
        bottom: -40px;
        width: 26px;
        left: 50%;
        transform: translateX(-50%);
    }
}
</style>